import React from "react";
import { APPLICATION_FILTERS } from "../utils/applicationTags";

interface ApplicationToggleProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
}

const ApplicationToggle: React.FC<ApplicationToggleProps> = ({ value, onChange, id = "app-toggle" }) => {
  return (
    <div className="app-toggle" id={id} role="group" aria-label="Filter by application">
      {APPLICATION_FILTERS.map((filter) => (
        <button
          key={filter.value || "all"}
          type="button"
          className={`app-toggle-btn ${value === filter.value ? "active" : ""}`}
          data-app={filter.value}
          onClick={() => onChange(filter.value)}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default ApplicationToggle;